module.exports = __webpack_public_path__ + "img/onboarding-calendar-essilor.4f27eda6.png";